import {Component, OnDestroy, OnInit} from '@angular/core';
import {ComplianceCalculateService} from '../../../../services/wizard-form-groups-services/compliance-calculate.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {LaboratoryStaffService} from '../../../../services/wizard-form-groups-services/nested-forms/laboratory-staff.service';

@Component({
    selector: 'app-wizard-staff-list',
    templateUrl: 'staff-list.component.html',
    styleUrls: ['staff-list.component.scss']
})

export class StaffListComponent implements OnInit, OnDestroy {
    public idsToRemove: number[] = [];

    private destroy$ = new Subject();

    constructor(
        public complianceTableService: ComplianceCalculateService,
        private laboratoryStaffService: LaboratoryStaffService,
    ) {
    }

    ngOnInit() {
        this.complianceTableService.specialists$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => {
            this.idsToRemove = [];
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
    }

    onCheckChange(id: number, checked: boolean) {
        if (checked) {
            if (!this.idsToRemove.includes(id)) {
                this.idsToRemove.push(id);
            }
        } else {
            const index = this.idsToRemove.indexOf(id);
            if (index >= 0) {
                this.idsToRemove.splice(index, 1);
            }
        }
    }

    remove() {
        this.laboratoryStaffService.remove(this.idsToRemove);
    }

    chooseSpecialist(specialistId: number) {
        this.laboratoryStaffService.add(+specialistId);
    }
}
